export default "__VITE_ASSET__BxntU4GA__"